
import { City } from "@/models/City";
import { Game } from "@/models/Game";
import { cloneDeep, isEqual, toArray } from "lodash";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import LanguageSelectCard from "../Base/LanguageSelectCard.vue";
import SavePanel from "../Base/SavePanel.vue";
import PoiErrors from "./ComposePoiTabs/QuestTabs/PoiErrors.vue";
import PoiGeneral from "./ComposePoiTabs/QuestTabs/PoiGeneral.vue";
import PoiExitGoals from "./ComposePoiTabs/QuestTabs/PoiExitGoals.vue";
import PoiDialog from "./ComposePoiTabs/QuestTabs/PoiDialog.vue";
import PoiMiniGame from "./ComposePoiTabs/QuestTabs/PoiMiniGame.vue";
import CloneQuestPoi from "./ComposePoiTabs/PoiAdd/CloneQuestPoi.vue";
import { MapPoiWarning } from "@/models/MapPois/Base/MapPoiWarning";
import QuestGameErrors from "@/utils/ErrorQuest/QuestGameErrors";
import QuestGameWarnings from "@/utils/ErrorQuest/QuestGameWarnings";
import { Season } from "@/models/GameType";
import {
  ActionRefData,
  QuestMapPoi,
  Quest_CG_MinigameSection,
} from "@/models/MapPois/Quest/QuestMapPoi";
import {
  MiniGame,
  MINIGAME_TYPE,
  MultiChoicePuzzleData,
} from "@/models/MapPois/Quest/Puzzle";
import DeleteBoxQuest from "../Base/DeleteBoxQuest.vue";
import { Quests } from "@/models/MapPois/Quest/Quests";

@Component({
  components: {
    LanguageSelectCard,
    SavePanel,
    CloneQuestPoi,
    PoiErrors,
    PoiGeneral,
    PoiExitGoals,
    PoiDialog,
    PoiMiniGame,
    DeleteBoxQuest,
  },
})
class EditPoiVertical extends Vue {
  @Prop({ default: null }) readonly mapKey!: string;
  @Prop({ default: null }) readonly cityData!: City;
  @Prop({ default: null }) readonly gameUid!: string;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  tabPicked = 0;
  showSavePanel = false;
  isSavedOrDiscard = false;
  mapPoiDataClone = {} as QuestMapPoi;
  mapPoiObject = {} as QuestMapPoi;
  warningObject = {} as MapPoiWarning;
  contentGroupData = {} as any;
  deleteBoxTitle = "";
  deleteBoxMessage = "";
  dialogName = "";
  showPoi = false;
  contentId = 1;
  idText = "";
  typePicked = "";
  componentKey = 0;
  isAmentity = false;

  get getMapPoi(): QuestMapPoi {
    return this.$store.state.mapPoiStore.questMapPoi.find(
      (x: QuestMapPoi) => x.key === this.mapKey
    );
  }

  get getQuestData(): Quests[] {
    return this.$store.state.questStore.quest;
  }

  get getContentId(): string {
    return "cg" + this.contentId;
  }

  get getAmentityType(): boolean {
    if (this.getMapPoi.type === "amenities") {
      return true;
    }
    return false;
  }

  get getContentGroupNumber(): number {
    if (this.getMapPoiObject.title.en === "START_ZONE") {
      return 0;
    }
    return Object.keys(this.getMapPoi.contentGroups).length;
  }

  get getGame(): Game {
    return this.$store.state.gameStore.games.find(
      (x: Game) => x.key == this.gameUid
    );
  }

  get getMapPoiObject(): QuestMapPoi {
    return this.mapPoiObject;
  }
  get getSeason(): Season {
    return this.$store.state.gameStore.gameType.filter(
      (t: Season) => t.slug == this.getGame.seas_uid
    )[0];
  }

  get getContentGroupArray(): any[] {
    return toArray(this.getMapPoiObject.contentGroups);
  }

  get getCityData(): City {
    return this.$store.state.cityStore.singleCity;
  }

  get getMapPoiData(): QuestMapPoi[] {
    return this.$store.state.mapPoiStore.questMapPoi;
  }

  get showButton(): boolean {
    if (this.getMapPoi.key === "START_ZONE") {
      return false;
    }
    return true;
  }

  get getTabbedPicked(): number {
    return this.tabPicked;
  }

  getCssClass(
    value: any,
    name: string,
    index: number,
    tabPicked: number
  ): string {
    if (this.isSelected(value, name)) {
      if (this.tabPicked === tabPicked && index == this.contentId) {
        return "quest-poi-menu-sub-item-active";
      }
      return "quest-poi-menu-sub-item";
    } else {
      return "quest-poi-menu-sub-item-non-active";
    }
  }

  isSelected(value: any, name: string): boolean {
    var names = Object.keys(value);
    return names.includes(name);
  }

  getContentGroupItemsArray(value: any): any[] {
    return Object.keys(value);
  }

  handleSubmitPressed(): void {
    this.showPoi = true;
  }
  closeDialog(): void {
    this.showPoi = false;
    this.handleClose();
  }

  created(): void {
    this.mapPoiObject = cloneDeep(this.getMapPoi);
    this.mapPoiDataClone = cloneDeep(this.getMapPoi);
    this.$store.commit("mapPoiStore/currentlyEditing", false);
    this.$nextTick(function() {
      this.$bvModal.show("team-modal-edit-poi");
    });
  }
  discardChanges(value: boolean): void {
    this.mapPoiObject = cloneDeep(this.getMapPoi);
    this.showSavePanel = false;
    this.getMapPoi;
    this.isSavedOrDiscard = true;
    this.changeAmentity(this.getMapPoi.type);
  }

  saveChanges(value: boolean): void {
    try {
      var data = {
        game_uid: this.gameUid,
        mapPoi: this.mapPoiObject,
      };
      this.$store.dispatch("mapPoiStore/updateMapPoiType", data);
      new QuestGameErrors(
        this.gameUid,
        this.getMapPoiData,
        this.getQuestData,
        this.getCityData,
        this.getSeason,
        this.$store.state.gameStore.games
      ).checkGameErrors();
      new QuestGameWarnings(
        this.gameUid,
        this.getMapPoiData,
        this.getQuestData,
        this.getCityData,
        this.getSeason,
        this.$store.state.gameStore.games
      ).checkGameWarnings();
      this.mapPoiDataClone = cloneDeep(this.mapPoiObject);
      this.showSavePanel = false;
      if (!value) {
        this.isSavedOrDiscard = true;
      }
    } catch (error) {
      console.log(error);
    }
  }

  updateTempObject(data: any): void {
    this.mapPoiObject = cloneDeep(data);
    this.isSavedOrDiscard = false;
    if (!isEqual(this.mapPoiObject, this.mapPoiDataClone)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
  }

  runErrorCheck(): void {
    new QuestGameErrors(
      this.gameUid,
      this.getMapPoiData,
      this.getQuestData,
      this.getCityData,
      this.getSeason,
      this.$store.state.gameStore.games
    ).checkGameErrors();
    new QuestGameWarnings(
      this.gameUid,
      this.getMapPoiData,
      this.getQuestData,
      this.getCityData,
      this.getSeason,
      this.$store.state.gameStore.games
    ).checkGameWarnings();
  }

  handleNavSelection(index: number, name: string, value: any): void {
    this.contentId = index;
    this.dialogName = name;
    this.componentKey += 1;
    if (name == "d1") {
      if (name == "d1" && value.d1 !== undefined) {
        this.tabPicked = 3;
      }
    }
    if (name == "mg") {
      if (value.mg !== undefined) {
        this.tabPicked = 4;
      }
    }
    if (name == "d2") {
      if (name == "d2" && value.d2 !== undefined) {
        this.tabPicked = 5;
      }
    }
    if (name == "exitGoals") {
      this.tabPicked = 6;
    }
  }

  addDialog(value: any, name: string): void {
    if (!this.isEditingLocked) {
      value[name] = {
        txt: { en: "" },
        title: { en: "" },
      };
    }
  }

  changeAmentity(type: string): void {
    if (type === "amenities") {
      this.isAmentity = true;
    } else {
      this.isAmentity = false;
    }
  }

  addMiniGame(value: any, name: string): void {
    if (!this.isEditingLocked) {
      var multiChoicePuzzleData: MultiChoicePuzzleData = {
        q: { txt: { en: "" }, imgs: "", audio: { en: "" } },
        a: {
          a0: { correct: false, txt: { en: "" } },
          a1: { correct: false, txt: { en: "" } },
          a2: { correct: false, txt: { en: "" } },
        },
        onFail: {
          txt: { en: "Failed!" },
          actions: {
            timerAction: { value: 5, parentID: "", status: "" },
          },
        },
        onSuccess: {
          txt: { en: "Success!" },
        },
        onIncorrect: {
          txt: { en: "Oops!" },
          actions: {
            timerAction: { value: 1, parentID: "", status: "" },
          },
        },
      };
      var miniGamePuzzle: MiniGame = {
        lobbyType: "solo",
        attempts: 2,

        puzzleData: {
          default: multiChoicePuzzleData,
        },
        tutorial: {
          imgs: "",
          txt: { en: "Select the answer from the given options!" },
          audio: { en: "" },
          title: { en: "Multiple Choice" },
        },
        timeout_s: 0,
        styleID: 0,
        dismissable: false,
      };
      var miniGame: Quest_CG_MinigameSection = {
        type: MINIGAME_TYPE.MULTI_CHOICE,
        title: { en: "" },
        intro: {
          imgs: "",
          title: { en: "" },
          txt: { en: "" },
          audio: { en: "" },
        },
        puzzle: miniGamePuzzle,
      };
      value[name] = miniGame;
    }
  }

  openNewContentGroup(): void {
    this.$bvModal.show("team-modal-sure");
  }
  createNewContentGroup(): void {
    try {
      this.getMapPoiObject.contentGroups[
        "cg" + (this.getContentGroupNumber - 1)
      ].exitGoals = {};
      this.getMapPoiObject.contentGroups["cg" + this.getContentGroupNumber] = {
        d1: {
          title: { en: "" },
          txt: { en: "" },
          imgs: "",
        },
      };
      var data = {
        mapPoi: this.getMapPoiObject,
        game_uid: this.gameUid,
      };
      this.$store.dispatch("mapPoiStore/updateMapPoiType", data);
      this.$bvModal.hide("team-modal-sure");
    } catch (error) {
      console.log(error);
    }
  }
  close(): void {
    this.$bvModal.hide("team-modal-sure");
    this.$bvModal.hide("team-modal-delete");
  }

  openDeleteContentGroup(index: number): void {
    if (!this.isEditingLocked) {
      this.contentId = index;
      this.deleteBoxTitle = "Delete Content-Group";
      this.deleteBoxMessage =
        "This will delete the entire content-group  and may break other items that rely on it...";
      this.idText = this.getContentId;
      this.typePicked = "contentGroup";
      this.$bvModal.show("team-modal-delete-quest");
    }
  }
  openDeleteMiniGroup(index: number): void {
    if (!this.isEditingLocked) {
      this.contentId = index;
      this.deleteBoxTitle = "Delete Mini Game";
      this.deleteBoxMessage =
        "This will delete the entire mini game and may break other items that rely on it...";
      this.idText = "mg" + index;
      this.typePicked = "miniGame";
      this.$bvModal.show("team-modal-delete-quest");
    }
  }
  openDeleteDialogGroup(index: number): void {
    this.contentId = index;
    this.deleteBoxTitle = "Delete Dialog 2";
    this.deleteBoxMessage =
      "This will delete the entire Dailog 2 and may break other items that rely on it...";
    this.idText = "d" + index;
    this.typePicked = "dialog";
    this.$bvModal.show("team-modal-delete-quest");
  }
  deleteItem(type: string): void {
    try {
      var data = {
        mapPoi: this.getMapPoiObject,
        game_uid: this.gameUid,
      };
      if (type === "contentGroup") {
        delete this.getMapPoiObject.contentGroups["cg" + this.contentId];
        //Remove the previous content group exti goals
        if (
          this.getMapPoiObject.contentGroups["cg" + (this.contentId - 1)]
            .exitGoals !== undefined
        ) {
          if (this.getMapPoiObject.actionGoalRef !== undefined) {
            var exitResults = this.getMapPoiObject.actionGoalRef.filter(
              (x: ActionRefData) =>
                x.path.includes("cg" + (this.contentId - 1) + "/exitGoals/")
            );
            exitResults.forEach((x: ActionRefData) => {
              var index = this.getMapPoiObject.actionGoalRef?.findIndex(
                (y) => y.path === x.path
              );
              if (index !== undefined && index > -1)
                this.getMapPoiObject.actionGoalRef?.splice(index, 1);
            });
          }
          delete this.getMapPoiObject.contentGroups["cg" + (this.contentId - 1)]
            .exitGoals;
        }
        delete this.getMapPoiObject.contentGroups["cg" + (this.contentId - 1)]
          .exitGoals;

        if (this.getMapPoiObject.actionGoalRef !== undefined) {
          var results = this.getMapPoiObject.actionGoalRef.filter(
            (x: ActionRefData) => x.path.includes("cg" + this.contentId)
          );
          results.forEach((x: ActionRefData) => {
            var index = this.getMapPoiObject.actionGoalRef?.findIndex(
              (y) => y.path === x.path
            );
            if (index !== undefined && index > -1)
              this.getMapPoiObject.actionGoalRef?.splice(index, 1);
          });
        }
      }
      if (type === "miniGame") {
        delete this.getMapPoiObject.contentGroups["cg" + this.contentId].mg;
        if (this.getMapPoiObject.actionGoalRef !== undefined) {
          var results1 = this.getMapPoiObject!.actionGoalRef!.filter(
            (x: ActionRefData) =>
              x.path.includes("cg" + this.contentId) && x.path.includes("mg")
          );
          results1.forEach((x: ActionRefData) => {
            var index = this.getMapPoiObject.actionGoalRef?.indexOf(x) || -1;
            if (index > -1)
              this.getMapPoiObject.actionGoalRef?.splice(index, 1);
          });
        }
      }
      if (type === "dialog") {
        delete this.getMapPoiObject.contentGroups["cg" + this.contentId].d2;
        if (this.getMapPoiObject.actionGoalRef !== undefined) {
          var results2 = this.getMapPoiObject!.actionGoalRef!.filter(
            (x: ActionRefData) =>
              x.path.includes("cg" + this.contentId) && x.path.includes("d2")
          );
          results2.forEach((x: ActionRefData) => {
            var index = this.getMapPoiObject.actionGoalRef?.indexOf(x) || -1;
            if (index > -1)
              this.getMapPoiObject.actionGoalRef?.splice(index, 1);
          });
        }
      }
      this.tabPicked = 0;
      this.$store.dispatch("mapPoiStore/updateMapPoiType", data);
    } catch (erorr) {
      console.log(erorr);
    }
  }

  handleClose(): void {
    this.$bvModal.hide("team-modal-edit-poi");
    this.$emit("closeEditPoi");
  }
  @Watch("getMapPoi", { deep: true })
  async onPropertyChanged(): Promise<void> {
    this.mapPoiObject = cloneDeep(this.getMapPoi);
  }
}

export default EditPoiVertical;
